export const CHANNEL_ICON = {
    pstnphone: 'phone',
    email: 'mail',
    widgetchat: 'chat',
    messenger: 'messenger',
    facebookmessenger: 'facebook-messenger',
    whatsapp: 'whatsapp',
    sms: 'sms',
    callback: 'callback',
    voicemail: 'voicemail',
    contactform: 'chat-widget',
    twitter: 'twitter',
};
